

/* Load product by term ID in GIFTS template */

  // gets element index
function elIndex(el) {
  if (!el) return -1;
  var i = 0;
  while (el = el.previousElementSibling) {
    i++;
  }
  return i;
}

if ( document.querySelectorAll('body.home .products').length > 0 ) {

    setUnderlineCurrentlyActiveCategory();

    const productCats = document.querySelectorAll('body.home .products .product-cats a');
    for (let index = 0; index < productCats.length; index++) {
      productCats[index].addEventListener('click', function() {
        var catId = this.getAttribute("data-product-cat-id");
        var termWidth = this.offsetWidth;
        var offset = this.getBoundingClientRect().left - this.parentNode.getBoundingClientRect().left;

        changeUnderlinePosition( termWidth, offset )

        if ( window.innerWidth < 768 ) {
          var allTermsWidth = 0;
          var activeTermOffset = 0;
          var index = elIndex( this );
          setUnderline( allTermsWidth, activeTermOffset, index );
        }

        loadProducts( catId );

        for (let i = 0; i < productCats.length; i++) {
          productCats[i].classList.remove('active');
        }
        this.classList.add('active');
      })
    }
  }

  // Sets underline position for active category on page initial load
  function setUnderlineCurrentlyActiveCategory() {

    var activeTerm = document.querySelector('body.home .products .product-cats a.active');
    var activeTermWidth = activeTerm.offsetWidth;
    var activeTermOffset = activeTerm.getBoundingClientRect().left - activeTerm.parentNode.getBoundingClientRect().left;

    changeUnderlinePosition( activeTermWidth, activeTermOffset );

    if ( window.innerWidth < 768 ) {
      var allTermsWidth = 0;
      var index = elIndex( document.querySelector('body.home .products .product-cats a.active') );
      activeTermOffset = 0;

      setUnderline( allTermsWidth, activeTermOffset, index );
    }
  }

  // Sets underline position for clicked products category
  function setUnderline( allTermsWidth, activeTermOffset, index ) {
    const productCats = document.querySelectorAll('body.home .products .product-cats a');
    for (let i = 0; i < productCats.length; i++) {
      allTermsWidth += productCats[i].offsetWidth;
      if ( i < index ) {
        activeTermOffset += productCats[i].offsetWidth;
      }
    }

    if ( document.querySelectorAll('.js-underline-line').length > 0 ) {
      document.querySelector('.js-underline-line').style.width = allTermsWidth + 'px';
    }
    if ( document.querySelectorAll('.js-underline').length > 0 ) {
      document.querySelector('.js-underline').style.transform = 'translateX(' + activeTermOffset + 'px)';
    }
  }

  // Loads products by category ID
  function loadProducts( catId ) {
    var products = document.querySelector("body.home #js-products");
    var filters = document.querySelector("body.home .product-cats");
    jQuery.ajax({
      url : "/wp/wp-admin/admin-ajax.php",
      type: "GET",
      data : {
        action: "loadProducts",
        catId: catId,
      },
      beforeSend: function() {
        products.classList.add('loading');
        filters.classList.add('loading');
      },
      success: (response) => {
        if ( response.success ) {
          products.innerHTML = response.data;
          products.classList.remove('loading');
          filters.classList.remove('loading');
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  // changes product category underline position
  function changeUnderlinePosition( termWidth, termOffset ) {
    if ( document.querySelectorAll('.js-underline').length > 0 ) {
      document.querySelector('.js-underline').style.width = termWidth + 'px';
      document.querySelector('.js-underline').style.transform = 'translateX(' + termOffset + 'px)';
    }
  }


